import styled from 'styled-components';
import { BehavioralInsightPresentationMode } from 'modules/domains/segmentation';
import { isNumberZero } from 'utils/numberHelpers';
import { maybeLocalizeInteger } from 'utils/i18nHelpers';
import { NumberInsightPanel } from './NumberInsightPanel';
import { useCustomBehavioralContext } from './contexts';
import { InsightType } from '../domain';
import { useTranslation } from '../hooks';

export const DATA_TEST = 'custom-behavioral-insights-section';

const Wrapper = styled.div`
  display: flex;
  grid-column: 1 / span 4;
  column-gap: ${({ theme }) => theme.spacing.values.plusHalf};
`;

export const CustomBehavioralInsightsSection = () => {
  const { cachedCustomBehavioralInsights } = useCustomBehavioralContext();
  const { t } = useTranslation();

  return (
    <Wrapper data-test={DATA_TEST}>
      {cachedCustomBehavioralInsights.map(({ event, behavior, mode, eventName }) => {
        const localizedValue = maybeLocalizeInteger(behavior?.value);
        const perUserValue = t('insights.showPerUser', { value: localizedValue });

        const value =
          mode === BehavioralInsightPresentationMode.TotalCount ? localizedValue : perUserValue;

        return (
          <NumberInsightPanel
            key={event}
            title={eventName}
            value={value}
            type={InsightType.behavioral}
            isZero={isNumberZero(behavior?.value)}
            isCustom
          />
        );
      })}
    </Wrapper>
  );
};
